import TableChat from './TableChat/TableChat';

export enum StreamType {
  CHAT = 'CHAT',
  SYSTEM = 'SYSTEM',
}

interface TableStreamHeaderParams {
  selectedStreamType: StreamType;
  setStreamType: (streamTable: StreamType) => void;
}

export const TableStreamHeader: React.FC<TableStreamHeaderParams> = ({ selectedStreamType, setStreamType }) => {
  const activeStyle = 'font-bold text-ph-purple border-b-2 border-ph-purple';
  return (
    <div className="flex h-9 w-full items-center justify-around border-b border-white border-opacity-30 text-center font-manrope font-bold leading-5 text-white text-opacity-30">
      <div className={`flexh-9 flex-1 items-center ${selectedStreamType === StreamType.CHAT && activeStyle}`}>
        <button onClick={() => setStreamType(StreamType.CHAT)} className="mx-auto truncate text-xs font-bold">
          {StreamType.CHAT}
        </button>
      </div>
      <div className={`flex h-9 flex-1 items-center ${selectedStreamType === StreamType.SYSTEM && activeStyle}`}>
        <button onClick={() => setStreamType(StreamType.SYSTEM)} className="mx-auto truncate text-xs font-bold">
          {StreamType.SYSTEM}
        </button>
      </div>
    </div>
  );
};

interface TableStreamParams {
  tableId: string;
  userId: string;
  streamType: StreamType;
  setStreamType: (streamTable: StreamType) => void;
}

const TableStreams: React.FC<TableStreamParams> = ({ tableId, userId, streamType, setStreamType }) => {
  if (streamType === StreamType.CHAT) {
    return <TableChat tableId={tableId} userId={userId} setStreamType={setStreamType} />;
  }
  if (streamType === StreamType.SYSTEM) {
    return <TableChat tableId={tableId} userId={userId} setStreamType={setStreamType} streamType={StreamType.SYSTEM} />;
  }

  return <></>;
};
export default TableStreams;
